module.exports = __webpack_public_path__ + "img/yq4.3799aeff.png";